<!-- eslint-disable -->
<template>
<div 
  @click="selectJoin"
  class="p2s2c2_container"
  :class="{p2s2c2_selected_entry: isActiveRuleJoin==true}"
  >
    <div class="p2s2c2_assigned_type_label">
      {{assignedTypeLabel}}
    </div>
  <div class="p2s2c2_org_label">
    <c22-full-path-label
      :objectUid="objectUid"
      :objectAttributeUid="objectAttributeUid"
      :hideSystemName="true"
      :hideObjectName="true"
      :hideObjectAttributeName="true"
      :showOrgParents="true"
      :dontUseDefaultFontSize="true"
    >
    </c22-full-path-label>
  </div>
  <div class="p2s2c2_exact_location">
    <c22-full-path-label
      :objectAttributeUid="objectAttributeUid"
      :objectUid="objectUid"
      :showOrgParents="false"
      :hideOrgName="true"
      :dontUseDefaultFontSize="true"
    >
    </c22-full-path-label>
  </div>

  <div 
    v-if="isActiveRuleJoin === true" 
    class="p2s2c2_edit_icon"
    @click="editJoin"
    >
  </div>
</div>
</template>
<script>
/* eslint-disable */
import c22FullPathLabel from "../../../Labels/c22FullPathLabel";
export default {
  name: "p2s2c2RuleJoinEntry",
  props: [
    "instantFlag",
    "doghouseFlag",
    "reportFlag",
    "objectUid",
    "ruleJoinUid",
    "objectAttributeUid",
    "selectedRuleJoinUid",
  ],
  components: {
    c22FullPathLabel,
  },
  data: function() {
    return {
      isActiveRuleJoin: false,
      assignedTypeLabel: "",
    };
  },

  mounted: function() {
    this.$nextTick(function() {
      this.setAssignedTypeLabel();
    });
  },
  methods: {
    editJoin: function(event) {
      this.$emit("event-edit-rule-join", this.ruleJoinUid);
    },
    selectJoin: function(event) {
      this.$emit("event-select-rule-join", [this.ruleJoinUid, this.objectAttributeUid]);
    },
    setAssignedTypeLabel() {
      var display_string = "";
      if (this.doghouseFlag === true) {
        display_string += "D ";
      }
      if (this.instantFlag === true) {
        display_string += "E ";
      }
      if (this.reportFlag === true) {
        display_string += "R ";
      }
      this.assignedTypeLabel = display_string;
    },
  },
  watch: {
    selectedRuleJoinUid() {
      if (typeof this.ruleJoinUid === "string" && this.ruleJoinUid === this.selectedRuleJoinUid) {
        this.isActiveRuleJoin = true;
      } else {
        this.isActiveRuleJoin = false;
      }
    },
    instantFlag() {
      this.setAssignedTypeLabel();
    },
    doghouseFlag() {
      this.setAssignedTypeLabel();
    },
    reportFlag() {
      this.setAssignedTypeLabel();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2/p2s2c2RuleJoinEntry.vue